<template>
  <div class="announcements-page">
    <div class="page-header">
      <h1>Moje ogłoszenia</h1>
      <button class="btn-primary" @click="$router.push('/profile/announcements/add')">
        + Dodaj ogłoszenie
      </button>
    </div>

    <section class="section-card" v-if="isEditModalVisible">
      <div class="section-card-header">
        <h2>Edycja ogłoszenia</h2>
      </div>

      <form class="edit-form" @submit.prevent="(e) => editAnnouncement(e)">
        <input type="text" placeholder="tytuł" v-model="editModalDetails.titleValue" name="title" required maxlength="50" minlength="3">
        <textarea placeholder="krótki opis" v-model="editModalDetails.shortDescriptionValue" name="short_description" required maxlength="350" minlength="20"></textarea>
        <textarea placeholder="treść" v-model="editModalDetails.contentValue" name="content" required maxlength="3000" minlength="80"></textarea>
        <input type="email" placeholder="adres e-mail do kontaktu" autocomplete="email" v-model="editModalDetails.contact" maxlength="50" required>

        <div class="form-row">
          <div class="form-col">
            <label for="target">Odbiorcy</label>
            <select name="target" id="target" v-model="editModalDetails.target" required>
              <option>do wszystkich</option>
              <option>do specjalistów</option>
              <option>do właścicieli zwierząt</option>
            </select>
          </div>

          <div class="form-col">
            <label for="category">Kategoria</label>
            <select name="category" id="category" v-model="editModalDetails.category" required>
              <option>sprzedaż</option>
              <option>współpraca</option>
              <option>wymiana</option>
              <option>inne</option>
            </select>
          </div>
        </div>

        <label for="announcementImage">Zdjęcie wyróżniające</label>
        <input type="file" id="announcementImage" @change="(e) => onFileUpload(e)" accept="image/png, image/jpeg">

        <div class="form-actions">
          <button type="submit" class="btn-green">Zatwierdź</button>
          <button type="button" class="btn-outline" @click="() => isEditModalVisible = false">Anuluj</button>
        </div>
      </form>
    </section>

    <section class="section-card" v-if="currentUser && announcements.length > 0">
      <div class="section-card-header">
        <h2>Lista ogłoszeń</h2>
      </div>

      <div class="announcements-container">
        <AnnouncementCardVue
            :show-active="true"
            v-for="announcement in announcements"
            :key="announcement.id"
            :contact="announcement.contact"
            :active="announcement.active"
            :target="announcement.target"
            :category="announcement.category"
            :img="announcement.photo_url"
            :longContent="announcement.description"
            :id="announcement.id"
            :title="announcement.title"
            :content="announcement.short_description"
            :editable="true"
            :removable="true"
            :photo="announcement.photo"
            @deleteAnnouncement="(id) => deleteAnnouncement(id)"
            @showEditModal="({ titleValue, shortDescriptionValue, contentValue, id, target, contact, category }) => {
            isEditModalVisible = true;
            editModalDetails.titleValue = titleValue;
            editModalDetails.shortDescriptionValue = shortDescriptionValue;
            editModalDetails.contentValue = contentValue;
            editModalDetails.id = id;
            editModalDetails.target = target;
            editModalDetails.contact = contact;
            editModalDetails.category = category;
          }"
        />

        <button
            v-if="announcements.length >= 10"
            class="btn-outline btn-load-more"
            @click="() => {
            announcementsLimit += 5;
            getMyAnnouncements(announcementsLimit);
          }"
        >
          Załaduj więcej...
        </button>
      </div>
    </section>

    <section class="section-card" v-else>
      <div class="empty-state">
        <p>Brak ogłoszeń.</p>
      </div>
    </section>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import axios from 'axios';
import AnnouncementCardVue from '@/components/SpecialComponents/AnnouncementCard.vue';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'PrivProfileAnnouncementsVue',
  setup() {
    useMeta({ title: 'Moje ogłoszenia' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore()
    };
  },
  data() {
    return {
      announcements: [],
      announcementsLimit: 10,
      isEditModalVisible: false,
      editModalDetails: {
        titleValue: '',
        shortDescriptionValue: '',
        contentValue: '',
        id: '',
        contact: '',
        target: '',
        category: '',
        photo: null
      }
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 3) {
      this.$router.push('/login');
    }
    this.getMyAnnouncements(this.announcementsLimit);
  },
  methods: {
    getMyAnnouncements(limit) {
      const ob = {
        user_id: this.currentUser.id,
        page: 1,
        limit: limit
      };
      this.announcements = [];
      axios.post('/AnnouncementSearch', ob).then((res) => {
        res.data.items.forEach((item) => {
          const freshAnnouncement = {
            title: item.title,
            description: item.description,
            id: item.id,
            photo_url: item.photo_url,
            short_description: item.short_description,
            target: item.target,
            category: item.category,
            contact: item.contact,
            active: item.active
          };
          this.announcements.push(freshAnnouncement);
        });
      });
    },
    onFileUpload(e) {
      this.editModalDetails.photo = e.target.files[0];
    },
    deleteAnnouncement(id) {
      axios.delete(`/Announcement/${id}`, authHeader()).then((res) => {
        if (String(res.status).charAt(0) === '2') {
          this.appStore.setIsSuccess('Pomyślnie usunięto ogłoszenie');
          this.announcements = this.announcements.filter((item) => item.id !== id);
        }
      });
    },
    editAnnouncement() {
      const ob = {
        id: this.editModalDetails.id,
        title: this.editModalDetails.titleValue,
        short_description: this.editModalDetails.shortDescriptionValue,
        description: this.editModalDetails.contentValue,
        active: 0,
        contact: this.editModalDetails.contact,
        target: this.editModalDetails.target,
        category: this.editModalDetails.category
      };
      if (this.editModalDetails.photo) {
        ob.photo = this.editModalDetails.photo;
      }
      axios.post('/Announcement', ob, {
        headers: {
          ['Content-Type']: 'multipart/form-data'
        }
      }).then((res) => {
        if (String(res.status).charAt(0) === '2') {
          this.appStore.setIsSuccess('Pomyślnie zmieniono ogłoszenie');
          const editAnnouncement = this.announcements.filter((item) => item.id == this.editModalDetails.id)[0];
          editAnnouncement.title = this.editModalDetails.titleValue;
          editAnnouncement.description = this.editModalDetails.contentValue;
          editAnnouncement.short_description = this.editModalDetails.shortDescriptionValue;
          editAnnouncement.contact = this.editModalDetails.contact;
          editAnnouncement.target = this.editModalDetails.target;
          editAnnouncement.category = this.editModalDetails.category;
          this.isEditModalVisible = false;
        }
      });
    }
  },
  components: {
    AnnouncementCardVue
  }
};
</script>

<style scoped lang="scss">
.announcements-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  color: #1f2937;
  font-weight: 700;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .08);
  padding: 24px;
  margin-bottom: 20px;
  box-sizing: border-box;
}

.section-card-header h2 {
  margin: 0 0 16px 0;
  font-size: 2rem;
  color: #1f2937;
}

.announcements-container {
  display: grid;
  gap: 20px;
}

.edit-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.edit-form input,
.edit-form select,
.edit-form textarea {
  width: 100%;
  border: 1px solid #d1d5db;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 1.4rem;
  box-sizing: border-box;
  outline: none;
  background: #fff;
}

.edit-form textarea {
  resize: vertical;
  min-height: 100px;
}

.edit-form input:focus,
.edit-form select:focus,
.edit-form textarea:focus {
  border-color: #10b981;
}

.edit-form label {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
  margin-top: 4px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.form-col {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.btn-primary,
.btn-green,
.btn-outline {
  border-radius: 8px;
  border: none;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
}

.btn-primary {
  background: #f97316;
  color: #fff;
}
.btn-primary:hover {
  background: #ea6c0a;
}

.btn-green {
  background: #10b981;
  color: #fff;
}
.btn-green:hover {
  background: #059669;
}

.btn-outline {
  background: #fff;
  color: #1f2937;
  border: 1px solid #d1d5db;
}
.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.btn-load-more {
  justify-self: center;
  min-width: 180px;
}

.empty-state {
  text-align: center;
  color: #9ca3af;
  font-size: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
  padding: 24px;
}

@media (max-width: 720px) {
  .form-row {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .announcements-page {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card-header h2 {
    font-size: 1.8rem;
  }

  .btn-primary,
  .btn-green,
  .btn-outline {
    width: 100%;
    text-align: center;
  }
}
</style>